import pino from 'pino';

export const logger = pino({
  formatters: {
    level(label) {
      return { severity: label.toUpperCase() };
    },
  },
  level: 'info',
});

export enum Tag {
  PAYMENT = 'PAYMENT',
}

interface LogData<T> {
  tag: Tag;
  message: string;
  data: T;
}

export const logTagInfo = <T>({ tag, message, data }: LogData<T>) => {
  logger.info({ data, tag }, message);
};

export const logTagError = <T>({ tag, message, data }: LogData<T>) => {
  logger.error({ data, tag }, message);
};
